import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
	state:{
		loginUser:{role:0},
		title:'基于Vue框架下的旅游信息可视化大数据平台',
		loadingCount:0,
		backendHost:'http://127.0.0.1:8080',
		currentChatUser:{},
		currentNotice:{},
		wsUrl:'ws://127.0.0.1:8081/ws',
		msgCount:0,
		ws:null,
		blog:null,
		newMsg:null,
		style:{
			table:{
				headerCellStyle:{backgroundColor:'transparent',textAlign:'center'},
				headerRowStyle:{borderColor: 'red'},
				cellStyle:{textAlign:'center'},
				rowStyle:{borderColor: 'red'},
			},
		}
	},
	mutations:{
		addMsgCount(s,v){
			s.msgCount +=1
		},
		setNewMsg(s,v){
			s.newMsg = v
		},
		addLoadingCount(state,n){
			state.loadingCount+=1
		},
		removeLoadingCount(state,n){
			state.loadingCount-=1
		},
		setUser(state,user){
			state.loginUser=user
			localStorage.setItem('user',JSON.stringify(user))

		},
		setCurrentChatUser(state,user){
			state.currentChatUser=user
		},
		setCurrentNotice(state,n){
			state.currentNotice=n
		},
	}
})
export default store
